"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterMetric = void 0;
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
let ClusterMetric = class ClusterMetric {
};
exports.ClusterMetric = ClusterMetric;
__decorate([
    (0, property_1.Property)({ required: true }),
    __metadata("design:type", String)
], ClusterMetric.prototype, "podName", void 0);
__decorate([
    (0, property_1.Property)({ required: true }),
    __metadata("design:type", String)
], ClusterMetric.prototype, "containerName", void 0);
__decorate([
    (0, property_1.Property)({ required: true }),
    __metadata("design:type", Number)
], ClusterMetric.prototype, "cpuMillicores", void 0);
__decorate([
    (0, property_1.Property)({ required: true }),
    __metadata("design:type", Number)
], ClusterMetric.prototype, "memoryMegabytes", void 0);
__decorate([
    (0, property_1.Property)({
        type: () => Date,
        index: { expireAfterSeconds: 30 * 24 * 60 * 60 },
    }),
    __metadata("design:type", Object)
], ClusterMetric.prototype, "createdAt", void 0);
exports.ClusterMetric = ClusterMetric = __decorate([
    (0, mocks_1.modelOptions)({
        schemaOptions: {
            id: false,
            timestamps: true,
            versionKey: false,
        },
    })
], ClusterMetric);
